export default __webpack_public_path__ + "static/media/airbnb404.b7f6880a.gif";